import { useState, useEffect } from "react";
import { Snackbar, Alert, Badge } from "@mui/material";
import { useAuth } from "../components/AuthProvider.tsx";
import Moment from "moment-timezone";
import Application from "../models/Application.tsx"
import AdditionalDocument from "../models/AdditionalDocument.tsx";

interface Props {
  application: Application,
  AddAdditionalDocument: (document: AdditionalDocument) => void,
  DeleteAdditionalDocument: (index: number) => void
}

const AdditionalDocumentComponent = ({ application, AddAdditionalDocument, DeleteAdditionalDocument }: Props) => {
  const { authorization, SetAuthorization } = useAuth();
  const [title, SetTitle] = useState("");
  const [count, SetCount] = useState(0);
  const [error, SetError] = useState(false);

  useEffect(() => {
    SetCount(application.AdditionalDocuments.length);
  }, [application.AdditionalDocuments]);

  const Upload = (event: React.ChangeEvent) => {
    const file = event.target.files[0];
    const filename = file.name;

    // Verify maximum file size
    if (file.size > 4000000) {
      SetError(true);
      return;
    }

    // Send document to server
    const data = new FormData();
    data.append("Token", authorization.Token);
    data.append("BusinessId", application.BusinessId.toString());
    data.append("File", file);
    const options = {
      method: "POST",
      body: data
    };

    fetch("/api/document", options)
      .then(response => response.text())
      .then(data => {    
        var documentId = Number(data);
        fetch("/api/additionaldocument?token=" + authorization.Token + "&documentId=" + documentId)
          .then(response => response.json())
          .then(document_data => {
            var document:AdditionalDocument = document_data;
            document.Title = title.trim() ? title.trim() : "Additional Document #" + (application.AdditionalDocuments.length + 1);
            AddAdditionalDocument(document);
            SetTitle("");
            SetCount(application.AdditionalDocuments.length);
          })
          .catch(error => console.log(error));
      })
      .catch(error => console.error(error));
  }

  const Delete = (index: number) => {
    DeleteAdditionalDocument(index);
    SetCount(application.AdditionalDocuments.length);
  }

  const OnChange = (event: React.ChangeEvent<any>) => {
    const { name, value } = event.target;
    SetTitle(value);
  }

  return (
    <>
      <Snackbar open={error} onClose={() => SetError(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }} autoHideDuration={5000}>
        <Alert severity="error" variant="filled" sx={{ width: "100%", padding: 2 }}>
          Document exceeds the 4MB maximum file size.
        </Alert>
      </Snackbar>

      <h3>Additional Documents<Badge sx={{ marginLeft: 1, padding: 0.5 }} badgeContent={count} color="error" /></h3>
      {application.AdditionalDocuments.map((document, index) => (
        <p key={document.DocumentId} className="fileUploadParag">
          <label className="uploadInfo">
            {document.Title}:
            <span className="file-name"> <a href={'/api/document?token=' + authorization.Token + '&documentId=' + document.DocumentId} download>{document.Filename}</a>
              {authorization.IsAdministrator && <>&nbsp;&nbsp;{Moment.tz(document.CreatedOn, "America/Chicago").tz(Moment.tz.guess()).format("MMM DD, yyyy hh:mm A")}</>}&nbsp;
              <span className="tooltip">
                <img src="/images/icon-delete.png" alt="Delete" onClick={() => Delete(index)} />
                <span className="tooltiptext">Delete Document</span>
              </span>
            </span>
          </label>
        </p>
      ))}

      <p>
        <label className="biggerspace">
          Document Title<br />
          <input type="text" className="half" value={title} onChange={OnChange} />
          <label htmlFor="document" className="custom-file-label">Upload</label>
          <input type="file" id="document" className="custom-file-input" onChange={Upload} accept=".pdf, .doc, .docx" />
          <span className="file-name"></span>
        </label>
      </p>
    </>
  )
};

export default AdditionalDocumentComponent;